import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as ChevronDownIcon } from '@lifesize/ux-assets/vectors/svgIcons/chevron-down.svg';
import { ReactComponent as ChevronUpIcon } from '@lifesize/ux-assets/vectors/svgIcons/chevron-up.svg';
import classes from 'components/Chat/ChatList.module.scss';
import clsx from 'clsx';

const UnreadChatNav = (props) => {
  if (!props.showScroll) {
    return null;
  }

  const handleClick = () => {
    props.scrollToPos(props.scrollType);
  };

  return (
    <button className={clsx(classes.unreadChatNav, classes[props.scrollType])} onClick={handleClick}>
      <label>
        <FormattedMessage id="components.chat.unreadChatNav" defaultMessage="unread" />
        {props.scrollType === 'top' ? (
          <ChevronUpIcon data-testid="chevron-up" />
        ) : (
          <ChevronDownIcon data-testid="chevron-down" />
        )}
      </label>
    </button>
  );
};

UnreadChatNav.propTypes = {
  scrollType: PT.string,
  showScroll: PT.any,
  scrollToPos: PT.func
};

export default UnreadChatNav;
